import React, { useId, useState } from "react";
import { Info } from "lucide-react";

const MetricTooltip = ({
  children,
  content,
  isDarkMode,
  placement = "top", // "top" | "bottom" | "left" | "right"
  maxWidthClass = "max-w-xs",
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const tooltipId = useId();

  const pos =
    placement === "bottom"
      ? "top-full mt-2"
      : placement === "left"
      ? "right-full mr-2 top-1/2 -translate-y-1/2"
      : placement === "right"
      ? "left-full ml-2 top-1/2 -translate-y-1/2"
      : "bottom-full mb-2"; // top default

  const base =
    placement === "left" || placement === "right"
      ? "absolute z-50"
      : "absolute z-50 left-1/2 -translate-x-1/2";

  return (
    <span
      className="relative inline-flex"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
      onFocus={() => setIsVisible(true)}
      onBlur={() => setIsVisible(false)}
      tabIndex={0}
      aria-describedby={tooltipId}
    >
      {children}

      {isVisible && (
        <span
          id={tooltipId}
          role="tooltip"
          className={`
            ${base} ${pos}
            px-3 py-2 rounded-lg text-xs ${maxWidthClass} whitespace-normal shadow-lg
            ${isDarkMode
              ? "bg-gray-800 text-gray-200 border border-gray-700"
              : "bg-white text-gray-700 border border-gray-200 shadow-md"
            }
          `}
        >
          <span className="flex items-start gap-2">
            <Info size={12} className="flex-shrink-0 mt-0.5 text-indigo-400" />
            <span>{content}</span>
          </span>

          {/* Petit pointer (uniquement top/bottom pour rester simple) */}
          {(placement === "top" || placement === "bottom") && (
            <span
              className={`
                absolute left-1/2 -translate-x-1/2 border-4 border-transparent
                ${placement === "top" ? "top-full" : "bottom-full"}
                ${isDarkMode
                  ? placement === "top" ? "border-t-gray-800" : "border-b-gray-800"
                  : placement === "top" ? "border-t-white" : "border-b-white"
                }
              `}
            />
          )}
        </span>
      )}
    </span>
  );
};

export default MetricTooltip;
